import { withDefaults } from '@warp-drive/legacy/model/migration-support';

// EnumSettingResource supplies the attributes; pcs-program has no reciprocal pcsProgramSettings relationship.
const PcsProgramSettingSchema = withDefaults({
  type: 'pcs-program-setting',
  fields: [
    { kind: 'attribute', name: 'enum' },
    { kind: 'attribute', name: 'subject' },
    { kind: 'attribute', name: 'predicate' },
    { kind: 'attribute', name: 'value' },
    {
      kind: 'belongsTo',
      name: 'pcsProgram',
      type: 'pcs-program',
      options: { async: false, inverse: null },
    },
  ],
});

export default PcsProgramSettingSchema;
